import Pog from './Pog';

export default Pog;
